const HOUR = 3600

const stepMinutes = (span: number): number => {
	if (span > 6 * HOUR) {
		return 60
	}
	if (span > 2 * HOUR) {
		return 30
	}
	if (span > HOUR) {
		return 15
	}
	if (span > HOUR / 2) {
		return 5
	}
	return 1
}

export const timeTicks = (from: number, to: number): number[] => {
	const step = stepMinutes(to - from) * 60
	const offset = new Date(from * 1000).getTimezoneOffset() * 60
	const ticks: number[] = []
	for (let t = Math.ceil((from - offset) / step) * step + offset; t <= to; t += step) {
		ticks.push(t)
	}
	return ticks
}
